// extracted by mini-css-extract-plugin
export default {"submitButton":"ResetPasswordForm_submitButton__hW5Lg","loginLink":"ResetPasswordForm_loginLink__+C44K"};